import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {OperatoriesService} from '../operatories/operatories.service';
import {Globals} from '../../../globals';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {BusinessHoursTimeModel} from './models/business-hours-time.model';
import {StringUtils} from './utils/string-utils';
import {ScheduleTimesDaysConfigurationModel} from '../../../models/schedule/schedule-times-days-configuration.model';
import {WeekDaysEnum} from '../../../models/enum/week-days.enum';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {ScheduleBlockedTimesConfigurationModel} from '../../../models/schedule/schedule-blocked-times-configuration.model';
import {ScheduleTimeService} from '../../../services/configuration/schedule-time.service';
import {ScheduleTimesModel} from '../../../models/schedule/schedule-times.model';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {ITableData} from './models/i-table.data';
import {ColorSchemesService} from '../color-schemes/color-schemes.service';
import {ColorSchemeDataModel} from '../../../models/configuration/color-scheme-data.model';
import {DialogService} from '../../../services/dialog.service';
import {ConfigurationService} from '../configuration.service';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';

@Component({
  selector: 'app-business-hours',
  templateUrl: './business-hours.component.html',
  styleUrls: ['./business-hours.component.scss']
})
export class BusinessHoursComponent implements OnInit {
  clientList: TdoClientConfigurationModel[];
  locationList: ClientLocationDataModel[];

  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  selectedLocationOperatories: OperatoryDataModel[];

  scheduleTimes: ScheduleTimesModel;

  isReadyToView = false;
  isBusy = false;

  timeIncrementList: Array<number>;
  timeList: Array<BusinessHoursTimeModel>;
  visibleTimeList: Array<BusinessHoursTimeModel>;

  hasWarnedOfBaseTimeChange = false;

  workHoursTableDisplayedColumns = ['dayOfWeek', 'start', 'end', 'actions'];
  workHoursTableDataSource: MatTableDataSource<ScheduleTimesDaysConfigurationModel>;

  blockedTimesTableDisplayedColumns = ['operatory', 'dayOfWeek', 'start', 'end', 'colorScheme', 'reason', 'actions'];
  blockedTimesTableDataSource: MatTableDataSource<ScheduleBlockedTimesConfigurationModel>;

  daysOfWeekEnumList: EnumValidValueItemModel[];
  colorSchemes: ColorSchemeDataModel[];

  constructor(private operatoriesService: OperatoriesService,
              private globals: Globals,
              private snackbar: MatSnackBar,
              private dialog: MatDialog,
              private staticDataService: StaticDataService,
              private scheduleTimeService: ScheduleTimeService,
              private dialogService: DialogService,
              public configurationService: ConfigurationService,
              private colorSchemeService: ColorSchemesService) {
    // Time increment dropdown data
    this.timeIncrementList = new Array<number>();
    for (let i = 1; i <= 12; i++) {
      this.timeIncrementList.push(15 * i);
    }

    // Time dropdowns data
    this.updateTimeList();
  }

  updateTimeList() {
    this.timeList = new Array<BusinessHoursTimeModel>();
    this.visibleTimeList = new Array<BusinessHoursTimeModel>();

    // Visible times lists
    if (this.scheduleTimes && this.scheduleTimes.scheduleTime) {
      if (this.scheduleTimes.scheduleTime.SchedulerTimeIncrement) {
        const numMinutesInDay = 24 * 60;
        const numIterations = numMinutesInDay / this.scheduleTimes.scheduleTime.SchedulerTimeIncrement;
        const tmp = new Array<number>();
        for (let i = 0; i < numIterations; i++) {
          // tmp.push(this.scheduleTimes.scheduleTime.SchedulerTimeIncrement * i);
          this.visibleTimeList.push(StringUtils.convertToTimeString(this.scheduleTimes.scheduleTime.SchedulerTimeIncrement * i));
        }
      }
    } else {
      const tmp = new Array<number>();
      for (let i = 0; i < 96; i++) {
        // tmp.push(15 * i);
        this.visibleTimeList.push(StringUtils.convertToTimeString(15 * i));
      }
    }

    // All times
    if (this.scheduleTimes && this.scheduleTimes.scheduleTime) {
      if (this.scheduleTimes.scheduleTime.SchedulerTimeIncrement) {
        const numMinutesInDay = 24 * 60;
        const numIterations = numMinutesInDay / this.scheduleTimes.scheduleTime.SchedulerTimeIncrement;

        for (let i = 0; i < numIterations; i++) {
          // tmp.push(this.scheduleTimes.scheduleTime.SchedulerTimeIncrement * i);
          const timeToAdd = this.scheduleTimes.scheduleTime.SchedulerTimeIncrement * i;
          // console.log('Time to add: ' + timeToAdd);
          const retTime = StringUtils.convertToTimeString(timeToAdd);
          if (this.scheduleTimes.scheduleTime.VisibleStartTime) {
            const startTime = StringUtils.convertViewStringToTime(this.scheduleTimes.scheduleTime.VisibleStartTime);
            const endTime = StringUtils.convertViewStringToTime(this.scheduleTimes.scheduleTime.VisibleEndTime);

            /*console.log('Start hours: ' + startTime.getHours());
            console.log('End hours: ' + endTime.getHours());
            console.log('Ret time hours: ' + retTime.hour24);*/

            /*console.log('Start minutes: ' + startTime.getMinutes());
            console.log('End minutes: ' + endTime.getMinutes());
            console.log('Ret time minutes: ' + retTime.minutes);*/

            if ((retTime.hour24 >= startTime.getHours()) &&
              (retTime.hour24 <= endTime.getHours())) {
              if (retTime.hour24 > startTime.getHours() && retTime.hour24 < endTime.getHours()) {
                this.timeList.push(retTime);
              } else {
                if (retTime.hour24 === startTime.getHours() && parseInt(retTime.minutes) >= startTime.getMinutes()) {
                  this.timeList.push(retTime);
                }

                if (retTime.hour24 === endTime.getHours() && parseInt(retTime.minutes) <= endTime.getMinutes()) {
                  this.timeList.push(retTime);
                }
              }
            }
          } else {
            this.timeList.push(retTime);
          }
        }
      }
    } else {
      // Defaults to 15 min increments when no value
      const tmp = new Array<number>();
      for (let i = 0; i < 96; i++) {
        // tmp.push(15 * i);
        this.timeList.push(StringUtils.convertToTimeString(15 * i));
      }
    }
  }

  ngOnInit(): void {
    this.colorSchemeService.getColorSchemes().subscribe((colorSchemeData) => {
      this.colorSchemes = colorSchemeData;

      this.operatoriesService.getClients().subscribe(data => {
        this.clientList = data;
        const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
        if (currentClient) {
          this.selectedClient = currentClient;
        } else {
          this.selectedClient = this.clientList[0];
        }

        this.operatoriesService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
          this.locationList = ldata;

          if (this.locationList.length > 0) {
            const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
            if (currentLoc) {
              this.selectedLocation = currentLoc;
            } else {
              this.selectedLocation = this.locationList[0];
            }
            const evt = new TdoDropdownChange();
            evt.value = this.selectedLocation;
            evt.isUserInput = true;
            this.onChangeLocation(evt);
          }
        });

      }, err => {
        console.log(err);
        this.isBusy = false;
      });
    });
  }

  onChangeClient(e: TdoDropdownChange) {
    if (!e.isUserInput) {
      return;
    }
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeClient(e.value);
          return;
        } else {
          //
        }
      });
    } else {
      this.changeClient(e.value);
    }
  }

  changeClient(client: TdoClientConfigurationModel) {
    this.isBusy = true;
    this.selectedClient = client;

    this.operatoriesService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe((ldata) => {
      this.isReadyToView = true;
      this.locationList = ldata;
      this.selectedLocation = null;

      if (this.locationList.length > 0) {
        this.selectedLocation = this.locationList[0];
        const evt = new TdoDropdownChange();
        evt.value = this.selectedLocation;
        evt.isUserInput = true;
        this.onChangeLocation(evt);
      }
      this.isBusy = false;
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  onChangeLocation(e: TdoDropdownChange) {
    // if (!e.isUserInput) {
    //   return;
    // }
    //

    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeLocation(e.value);
          return;
        } else {
          //
          const oldLoc = this.selectedLocation;
          this.selectedLocation = null;
          setTimeout(() => {
            this.selectedLocation = oldLoc;
          }, 10);
        }
      });
    } else {
      this.changeLocation(e.value);
    }
  }

  changeLocation(location: ClientLocationDataModel) {
    this.isBusy = true;
    this.selectedLocation = location;
    this.operatoriesService.getLocationOperatories(this.selectedLocation.LOCID.toString()).subscribe((odata) => {
      this.selectedLocationOperatories = odata;

      this.isBusy = false;
      this.isReadyToView = true;

      this.scheduleTimeService.getSchedule(this.selectedLocation.LOCID).subscribe((ssdata) => {
        this.scheduleTimes = ssdata;
        if (!this.scheduleTimes.scheduleTime.SchedulerTimeIncrement) {
          this.scheduleTimes.scheduleTime.SchedulerTimeIncrement = 15;
        }
        this.sortByDayAndStartTime(this.scheduleTimes.scheduleTimesDays);
        this.sortByDayAndStartTime(this.scheduleTimes.scheduleTimeBlockedTimes);
        this.workHoursTableDataSource= null;
        this.workHoursTableDataSource = new MatTableDataSource<ScheduleTimesDaysConfigurationModel>(this.scheduleTimes.scheduleTimesDays);
        this.blockedTimesTableDataSource = new MatTableDataSource<ScheduleBlockedTimesConfigurationModel>(this.scheduleTimes.scheduleTimeBlockedTimes);
        this.daysOfWeekEnumList = this.staticDataService.getValidValueItemsByItemIds([WeekDaysEnum.Sunday, WeekDaysEnum.Monday, WeekDaysEnum.Tuesday, WeekDaysEnum.Wednesday, WeekDaysEnum.Thursday, WeekDaysEnum.Friday, WeekDaysEnum.Saturday]);
        this.updateTimeList();
      });
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  get dropDownTimes() {
    const list = new Array<BusinessHoursTimeModel>();
    if (this.scheduleTimes && this.scheduleTimes.scheduleTime) {
      const tmp = new Array<number>();
      for (let i = 0; i < 48; i++) {
        tmp.push(30 * i);
        list.push(StringUtils.convertToTimeString(30 * i));
      }
    } else {
      const tmp = new Array<number>();
      for (let i = 0; i < 48; i++) {
        tmp.push(30 * i);
        list.push(StringUtils.convertToTimeString(30 * i));
      }
    }
    return list;
  }

  onSave(event) {
    const exists = this.scheduleTimes.scheduleTimesDays.findIndex( x => (x.SchedultTimeDayID === null || x.SchedultTimeDayID === undefined) && ((x.StartTime === null || x.StartTime === undefined)
    || (x.EndTime === null || x.EndTime === undefined)));
    if (exists !== -1){
      this.snackbar.open('Please select Start and End Time', '' , {duration: 5000});
      return;
    }

    this.scheduleTimeService.saveSchedule(this.scheduleTimes).subscribe((response) => {
      this.snackbar.open('Saved successfully', '' , {duration: 5000});
    });
  }

  onAddWorkHourDay(event) {
    if (this.scheduleTimes.scheduleTimesDays === undefined) {
      this.scheduleTimes.scheduleTimesDays = new Array<ScheduleTimesDaysConfigurationModel>();
    }
    const m1 = new ScheduleTimesDaysConfigurationModel();
    m1.LOCID = this.selectedLocation.LOCID;
    this.scheduleTimes.scheduleTimesDays.unshift(m1);
    this.refreshScheduleTimesTable();
  }

  onDeleteWorkHourDay(model: ScheduleTimesDaysConfigurationModel) {
    const idx = this.scheduleTimes.scheduleTimesDays.findIndex(p => p === model);
    if (model.SchedultTimeDayID === undefined) {
      this.scheduleTimes.scheduleTimesDays.splice(idx, 1);
      this.refreshScheduleTimesTable();
    } else {
      this.dialogService.openConfirmDialog(`Are you sure you want to delete this item?`).subscribe((result) => {
        if (result === true) {
          if (idx > -1) {
            this.scheduleTimeService.deleteScheduleTimesDay(model.SchedultTimeDayID).subscribe((response) => {
              if (response) {
              this.scheduleTimes.scheduleTimesDays.splice(idx, 1);
              this.refreshScheduleTimesTable();
              this.snackbar.open('Deleted work hours successfully', '', {duration: 5000});
            }
            });
          }
        }
      });
    }
  }

  onAddBlockedDay(event) {
    const m1 = new ScheduleBlockedTimesConfigurationModel();
    m1.LOCID = this.selectedLocation.LOCID;
    this.scheduleTimes.scheduleTimeBlockedTimes.push(m1);
    this.refreshScheduleBlockedTimesTable();
  }

  onDeleteBlockedDay(model: ScheduleBlockedTimesConfigurationModel) {
    const idx = this.scheduleTimes.scheduleTimeBlockedTimes.findIndex(p => p === model);
    if (model.SchedultTimeBlockID === undefined) {
      this.scheduleTimes.scheduleTimeBlockedTimes.splice(idx, 1);
      this.refreshScheduleBlockedTimesTable();
    } else {
      this.dialogService.openConfirmDialog(`Are you sure you want to delete this item?`).subscribe((result) => {
        if (result === true) {
          // this.isLoading = true;
          if (idx > -1) {
            this.scheduleTimeService.deleteScheduleBlockedTimesDay(model).subscribe((response) => {
              this.scheduleTimes.scheduleTimeBlockedTimes.splice(idx, 1);
              this.refreshScheduleBlockedTimesTable();
              this.snackbar.open('Deleted blocked work hours successfully', '' , {duration: 5000});
            });
          }
        }
      });
    }
  }

  refreshScheduleTimesTable() {
    this.workHoursTableDataSource._updateChangeSubscription();
  }

  refreshScheduleBlockedTimesTable() {
    this.blockedTimesTableDataSource._updateChangeSubscription();
  }

  getStartEndTimeByValue(value) {
    return this.visibleTimeList.find(p => p.time24String === value);
  }

  getVisibleTimeByValue(value) {
    return this.timeList.find(p => p.time24String === value);
  }

  getDayOfWeekByItemId(validValueId: string) {
    if (this.daysOfWeekEnumList) {
      const day = this.daysOfWeekEnumList.find(p => p.ValidValueItemId === validValueId);
      return day;
    } else {
      return null;
    }
  }

  getOperatoryById(operatoryId: string) {
    if (this.selectedLocationOperatories) {
      const operatory = this.selectedLocationOperatories.find(p => p.OperatoryId === operatoryId);
      return operatory;
    } else {
      return null;
    }
  }

  onDayOfWeekOrStartTimeChange(arr: ITableData[], type: string) {
    arr = this.sortByDayAndStartTime(arr);
    switch (type) {
      case 'times':
        this.refreshScheduleTimesTable();
        break;
      case 'blockedTimes':
        this.refreshScheduleBlockedTimesTable();
        break;
    }
  }

  sortByDayAndStartTime(data: ITableData[]) {
    return data.sort((a, b) => {

      if(a == null || b == null || a.enumWeekDaysID == null || b.enumWeekDaysID == null) {
        return 1;
      }


      const aWeekDayNum = parseInt(a.enumWeekDaysID.substring(34, 35));
      const bWeekDayNum = parseInt(b.enumWeekDaysID.substring(34, 35));
      if (aWeekDayNum > bWeekDayNum) {
        return 1;
      } else if (aWeekDayNum < bWeekDayNum) {
        return -1;
      } else {
        // 01:12 pm = 13:12
        const timeStringA = a.StartTime.split(' ')[0];
        const timeStringB = b.StartTime.split(' ')[0];

        const demarcationA = a.StartTime.split(' ')[1];
        const demarcationB = b.StartTime.split(' ')[1];

        const timeArrA = timeStringA.split(':');
        const timeArrB = timeStringB.split(':');

        let hourStringA = timeArrA[0];
        let hourStringB = timeArrB[0];

        const minuteStringA = timeArrA[1];
        const minuteStringB = timeArrB[1];

        if (hourStringA.charAt(0) === '0') {
          hourStringA = hourStringA.substring(1, 2);
        }

        if (hourStringB.charAt(0) === '0') {
          hourStringB = hourStringB.substring(1, 2);
        }

        let hourA = parseInt(hourStringA);
        let hourB = parseInt(hourStringB);
        const minuteA = parseInt(minuteStringA);
        const minuteB = parseInt(minuteStringB);

        if (demarcationA === 'pm') {
          hourA += 12;
          hourB += 12;
        }

        if (hourA > hourB) {
          return 1;
        } else if (hourA < hourB) {
          return -1;
        } else {
          if (minuteA > minuteB) {
            return 1;
          } else if (minuteA < minuteB) {
            return -1;
          } else {
            return 0;
          }
        }
        return 0;
      }
    });
  }

  onIncrementChange(event: any) {
    if (!this.hasWarnedOfBaseTimeChange) {
      this.dialogService.openConfirmDialog('Some currently selected times may be reset if you change the time increment, visible start time, or visible end time.  Are you sure?').subscribe((res) => {
        if (res) {
          this.hasWarnedOfBaseTimeChange = true;
          this.scheduleTimes.scheduleTime.SchedulerTimeIncrement = event.value;
          this.updateTimeList();
        } else {
          const lastTime = this.scheduleTimes.scheduleTime.SchedulerTimeIncrement;
          setTimeout(() => {
            this.scheduleTimes.scheduleTime.SchedulerTimeIncrement = null;
          }, 1);
          setTimeout(() => {
            this.scheduleTimes.scheduleTime.SchedulerTimeIncrement = lastTime;
          }, 10);

        }
      });
    }
  }

  onStartTimeChange(event: any) {
    if (!this.hasWarnedOfBaseTimeChange) {
      this.dialogService.openConfirmDialog('Some currently selected times may be reset if you change the time increment, visible start time, or visible end time.  Are you sure?').subscribe((res) => {
        if (res) {
          this.hasWarnedOfBaseTimeChange = true;
          this.scheduleTimes.scheduleTime.VisibleStartTime = event.value.time24String;
          this.updateTimeList();
        } else {
          const lastTime = this.scheduleTimes.scheduleTime.VisibleStartTime;
          setTimeout(() => {
            this.scheduleTimes.scheduleTime.VisibleStartTime = null;
          }, 1);
          setTimeout(() => {
            this.scheduleTimes.scheduleTime.VisibleStartTime = lastTime;
          }, 10);

        }
      });
    } else {
      this.scheduleTimes.scheduleTime.VisibleStartTime = event.value.time24String;
      this.updateTimeList();
    }
  }

  onEndTimeChange(event: any) {
    if (!this.hasWarnedOfBaseTimeChange) {
      this.dialogService.openConfirmDialog('Some currently selected times may be reset if you change the time increment, visible start time, or visible end time.  Are you sure?').subscribe((res) => {
        if (res) {
          this.hasWarnedOfBaseTimeChange = true;
          this.scheduleTimes.scheduleTime.VisibleEndTime = event.value.time24String;
          this.updateTimeList();
        } else {
          const lastTime = this.scheduleTimes.scheduleTime.VisibleEndTime;
          setTimeout(() => {
            this.scheduleTimes.scheduleTime.VisibleEndTime = null;
          }, 1);
          setTimeout(() => {
            this.scheduleTimes.scheduleTime.VisibleEndTime = lastTime;
          }, 10);

        }
      });
    } else {
      this.scheduleTimes.scheduleTime.VisibleEndTime = event.value.time24String;
      this.updateTimeList();
    }
  }
}
